// #region imports

// --- Angular
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

// --- HS Code
import { NotificationModel, NotificationTypes } from '../../../models';

// #endregion

@Component({
  selector: 'hs-notification-list',
  templateUrl: './notification-list.component.html',
  styleUrls: ['./notification-list.component.scss']
})
export class NotificationListComponent {
  @Input() notifications: NotificationModel[] | null = new Array<NotificationModel>;
  @Input() markAsReadLabel: string = '';
  @Input() downloadLabel: string = '';

  @Output() view = new EventEmitter<NotificationModel>();
  @Output() remove = new EventEmitter<NotificationModel>();

  notificationTypes = NotificationTypes;

  onView(notification: NotificationModel): void {
    this.view.emit(notification);
  }

  onRemove(notification: NotificationModel): void {
    this.remove.emit(notification);
  }
}
